<template>
    <v-app>
        <v-slide-y-reverse-transition>
            <v-bottom-navigation
              v-if="$store.getters['teacher/api_endpoint']"
              v-longpress="() => {$vuetify.theme.dark = !$vuetify.theme.dark}"
              app
              color="primary"
            >
                <v-btn :to="'/teacher/lessons/' + $route.params.hash" :class="{'v-btn--active': $route.meta.title == 'Lessons'}" text>
                    <span>Lessons</span>
                    <v-icon>school</v-icon>
                </v-btn>
                <v-btn :to="'/teacher/training/' + $route.params.hash" text>
                    <span>Training</span>
                    <v-icon>directions_run</v-icon>
                </v-btn>
            </v-bottom-navigation>
        </v-slide-y-reverse-transition>
        <v-main>
                <v-col md="10" offset-md="1" cols="12" offset="0" class="py-0 px-0">
                    <keep-alive>
                        <router-view v-if="$store.getters['teacher/initialized']">
                        </router-view>
                    </keep-alive>
                </v-col>
        </v-main>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
    </v-app>
</template>

<script>

import Vue from 'vue'
import LongPress from '../components/LongPress.js'

Vue.directive('longpress', LongPress)

export default {
    name: 'TeacherView',

    components: {
    },
    data () {
        return {
            snackbar_msg: '',
            snackbar: false,
        }
    },
    methods: {
        async initialize (hash) {
            try {
                await this.$store.dispatch('teacher/setup_credentials', hash);
            } catch (e) {
                if (e.response && e.response.status == 401) {
                    if (hash === window.localStorage.getItem('hash') && window.localStorage.getItem('type') == 'teacher'){
                        window.localStorage.removeItem('hash');
                        window.localStorage.removeItem('type');
                    }
                    this.$router.push({
                        path: '/error/unauthorized'
                    });
                } else {
                    this.snackbar_msg = 'Error authenticating';
                    this.snackbar = true;
                }
                return;
            }
            try {
                await this.$store.dispatch('teacher/get_lessons');
            } catch (e) {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
        }
    },
    async mounted () {
        await this.initialize(this.$route.params.hash);
    }
};
</script>

<style>

body {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none; /* Standard syntax */
}

.selectable {
  -webkit-user-select: auto !important; /* Safari */
  -ms-user-select: auto !important; /* IE 10+ and Edge */
  user-select: auto !important; /* Standard syntax */
}

.v-item-group.v-bottom-navigation .v-btn {
    height: inherit !important;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>
